import { Form, FormHandlers } from '@doveit/bricks';
import React from 'react';
import { asSelectOptions } from '../../../select-options/utils/asSelectOptions';
import { membershipLegalRoleLabels } from '../../../labels';

export interface MembershipContractFormModel {
  iban: string,
  bic: string,
  swift: string,
  role: string,
  companyName: string,
  vatNumber: string,
}

export interface MembershipContractFormProps extends React.AriaAttributes {
  initialValues?: Partial<MembershipContractFormModel>,
  innerRef?: React.MutableRefObject<FormHandlers>
  disabledFields?: Partial<Record<keyof MembershipContractFormModel, boolean>>,
  loading?: boolean,
  disabled?: boolean,
  onSubmit: (data: MembershipContractFormModel) => void,
}

export const EDIT_MEMBERSHIP_CONTRACT_FORM_DEFAULT_VALUES: MembershipContractFormModel = {
  iban: '',
  bic: '',
  swift: '',
  role: '',
  companyName: '',
  vatNumber: '',
};

const MembershipContractForm: React.FC<MembershipContractFormProps> = ({
  initialValues,
  disabled = false,
  loading = false,
  disabledFields,
  innerRef,
  ...rest
}) => {
  const mergedValues: MembershipContractFormModel = React.useMemo(() => ({
    ...EDIT_MEMBERSHIP_CONTRACT_FORM_DEFAULT_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      {...rest}
      initialValues={mergedValues}
      innerRef={innerRef}
      loading={loading}
      disabled={disabled}
      aria-label="Modifica contrattualistica"
      {...rest}
    >
      <Form.Fieldset legend="Firmatario collaborazione">
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Select
            name="role"
            label="Tipologia"
            disabled={disabledFields?.role}
            options={asSelectOptions(membershipLegalRoleLabels)}
          />
        </Form.Item>
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Input
            name="companyName"
            label="Ragione sociale"
            placeholder="Es. Company S.R.L."
            disabled={disabledFields?.companyName}
          />
        </Form.Item>
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Input
            name="vatNumber"
            label="Partita IVA"
            placeholder="Es. 86334519757"
            disabled={disabledFields?.vatNumber}
          />
        </Form.Item>
      </Form.Fieldset>

      <Form.Fieldset legend="Conto corrente">
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Input
            name="iban"
            label="IBAN"
            placeholder="Es. IT60X0542811101000000123456"
            disabled={disabledFields?.iban}
          />
        </Form.Item>
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Input
            name="bic"
            label="BIC"
            placeholder="Es. ABCDITMM123"
            disabled={disabledFields?.bic}
          />
        </Form.Item>
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Input
            name="swift"
            label="Swift"
            placeholder="Es. SWIFTBANK123"
            disabled={disabledFields?.swift}
          />
        </Form.Item>
      </Form.Fieldset>
    </Form>
  );
};

export default MembershipContractForm;
